import { merge } from 'rxjs/observable/merge';
import { ignoreElements } from 'rxjs/operator/ignoreElements';
import { Observable } from 'rxjs/Observable';
import { compose } from '@ngrx/store';

const /** @type {?} */ METADATA_KEY = '@ngrx/effects';
const /** @type {?} */ r: any = Reflect;

export interface EffectMetadata {
  propertyName: string;
  dispatch: boolean;
}
/**
 * @param {?} sourceType
 * @return {?}
 */
function hasStaticMetadata(sourceType: any): boolean {
  return !!( /** @type {?} */((sourceType as any))).propDecorators;
}
/**
 * @param {?} sourceType
 * @return {?}
 */
function getStaticMetadata(sourceType: any): EffectMetadata[] {
  const /** @type {?} */ propDecorators = sourceType.propDecorators;
  return Object.keys(propDecorators).reduce(
    (all, key) => all.concat(getStaticMetadataEntry(propDecorators[key], key)),
    []
  );
}
/**
 * @param {?} metadataEntry
 * @param {?} propertyName
 * @return {?}
 */
function getStaticMetadataEntry(metadataEntry: any, propertyName: string) {
  return metadataEntry
    .filter((entry: any) => entry.type === Effect)
    .map((entry: any) => {
      let /** @type {?} */ dispatch = true;
      if (entry.args && entry.args.length) {
        dispatch = !!entry.args[0].dispatch;
      }
      return { propertyName, dispatch };
    });
}
/**
 * @param {?} sourceProto
 * @return {?}
 */
function getEffectMetadataEntries(sourceProto: any): EffectMetadata[] {
  if (hasStaticMetadata(sourceProto.constructor)) {
    return getStaticMetadata(sourceProto.constructor);
  }

  if (r.hasOwnMetadata(METADATA_KEY, sourceProto)) {
    return r.getOwnMetadata(METADATA_KEY, sourceProto);
  }

  return [];
}
/**
 * @param {?} sourceProto
 * @param {?} entries
 * @return {?}
 */
function setEffectMetadataEntries(sourceProto: any, entries: EffectMetadata[]) {
  r.defineMetadata(METADATA_KEY, entries, sourceProto);
}
/**
 * \@Annotation
 * @param {?=} __0
 * @return {?}
 */
export function Effect({ dispatch } = { dispatch: true }): PropertyDecorator {
  return function(target: any, propertyName: string) {
    const /** @type {?} */ effects: EffectMetadata[] = getEffectMetadataEntries(target);
    const /** @type {?} */ metadata: EffectMetadata = { propertyName, dispatch };

    setEffectMetadataEntries(target, [...effects, metadata]);
  };
}
/**
 * @param {?} instance
 * @return {?}
 */
export function getSourceForInstance(instance: Object): any {
  return Object.getPrototypeOf(instance);
}

export const /** @type {?} */ getSourceMetadata = compose(
  getEffectMetadataEntries,
  getSourceForInstance
);



// WEBPACK FOOTER //
// ../../../modules/effects/src/effects_metadata.ts